import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";
import Content from "components/Content.js";

export default function Flutter() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="flutter">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">Hire The Best Flutter App Developers
</h2>
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">Hire The Best Flutter App Developers At Dave's Brother Technology</h1>
      <p class="lg:w-2/3 mx-auto leading-relaxed text-base">Known for its powerful native interface, Flutter can help you develop apps with vivid and flexible UIs. With Flutter, you can bring beautiful high-performing mobile apps to life. Dave's Brother Technology helps you reap all the benefits that come with Flutter, by getting you the talent that gets the job done!.</p>
    </div>
    <div class="flex flex-col text-center w-full mb-20">
     
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Why Choose Dave's Brother Technology To Hire Flutter App Developers?
</h1>
     
    </div>
    <div class="flex flex-wrap">
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">24x7 Unwavering Support</h2>
        <p class="leading-relaxed text-base mb-4">Fretting about loading time issues? Don't worry! Our Flutter app developers will be available to resolve any errors and problems for you instantaneously.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Flexible Hiring</h2>
        <p class="leading-relaxed text-base mb-4">Need Flutter app developers for a single project? On Dave's Brother Technology, you can hire a team of developers that will be committed to your project until its completion. What's more? You can vary your team size according to your needs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Save Time & Money</h2>
        <p class="leading-relaxed text-base mb-4">You don't need to break your bank to hire Flutter app developers anymore. EngineerBabu smoothens the hiring process for you - It's economical and best suited for startups/SMEs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Customer Is King!</h2>
        <p class="leading-relaxed text-base mb-4">You are our priority. We are resilient about the service we provide and make sure you get to work with the best Flutter app developers!</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
    </div>
    
  </div>
</section>
<Content />
<Footer />
    </>
  );
}